module.exports = __webpack_public_path__ + "img/kanban-fill.7c684f56.svg";